import loadjs from "loadjs";

// Ladda in Momentums API
window.momentumAlpine = function() {
  return {
    initMomentumFrame() {
      $("#momentum").momentumFrame({
        version: 4.25,
        design: "armada", //fråga momentum om denna variabel
        hmsDomain: "marknad", //ex vid marknad.foretag.se ska denna vara marknad })
        scrollTopOnPageLoad: false,
      });
    },
    mounted() {
      loadjs(
        [
          "https://code.jquery.com/jquery-3.5.1.min.js",
          "https://marknad.armadafast.se/scripts/momentum/jquery.momentum-iframe-0.1.js",
        ],
        {
          success: this.initMomentumFrame,
          async: false,
        }
      );
    },
  };
};

window.momentumLoginBox = function() {
  return {};
};
